import React, { useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Global from "../../util/Global";
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { LoaderComponent } from "../../util/Loader";
import Pagination from "../../components/Pagination";
import { Button, Chip, IconButton, Tooltip } from "@mui/material";
import { AlertContext } from "../../util/Alerter";
import NotFound from "../../components/NotFound";
import VisibilityIcon from '@mui/icons-material/Visibility';


const ANNANCES_URL = Global.backend + "/index.php/allAds";
const UPDATE_ANNONCE = Global.backend + "/index.php/updateEtat";

const AdminAnnonceList = () => {
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext)
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(true);
  const [annonces, setAnnonces] = useState([]);
  const [paginatedItems, setpaginatedItems] = useState([])




  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)

  useEffect(() => {
    setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    setpageTitle("adsList")
    setalertTitle("")
    setnavLinks([])
  }, [])


  useEffect(() => {
    setisLoading(true)

    fetchAds()
  }, []);


  function fetchAds() {
    axios.get(ANNANCES_URL)
      .then((response) => {
        setAnnonces(response.data);
      }).catch(() => {
        showAlert("error", t("request.errorFetchingAds"))
      })
      .finally(() => {
        setisLoading(false);
      });
  }



  const alertConfirm = (adId, state) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success ml-3",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });



    swalWithBootstrapButtons
      .fire({
        title: t("alertTitle.confirm"),
        text: state ? (state == -1 ? t("rejectAd") : t("approveAd")) : t("waitingAd"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("alertButton.ok"),
        cancelButtonText: t("alertButton.cancel"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          updateEtat(adId, state)
        }
      });

  };








  function updateEtat(annonceId, state = 0) {
    setisLoading(true)
    axios.post(UPDATE_ANNONCE, { annonceId, etat: state }).then(() => {
      if (state) {
        if (state == -1) {
          showAlert("success", t("adRejected"))
        } else {
          showAlert("success", t("adApproved"))
        }
      } else {
        showAlert("success", t("adWaiting"))
      }
      
      setAnnonces(annonces.map(ads=>{
        if(ads.id==annonceId){
          ads.etat=state
        }
        return ads
      }))
      
    }).catch((err) => {
      showAlert("error", t("request.errorUpdatingAdState"))
    }).finally(() => {
      setisLoading(false)
    })
  }









  return (
    <LoaderComponent isLoading={isLoading}>
      {!isLoading && (
        !annonces.length ? <NotFound /> :
          <div className="card">
            <div className="card-body">
              <div className="table-responsive mt-3">
                <table
                  className="table table-centered datatable dt-responsive nowrap "
                  style={{
                    borderCollapse: "collapse",
                    borderSpacing: "0",
                    width: "100%",
                  }}
                >
                  <thead className="thead-light">
                    <tr>
                      <th>{t("ads.image")}</th>
                      <th>{t("ads.title")}</th>
                      <th>{t("ads.publishDate")}</th>
                      <th>{t("ads.category")}</th>
                      <th>{t("ads.state")}</th>
                      <th >{t("ads.action")}</th>
                      <th>{t("ads.details")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.map((annonce, index) => (
                      <tr key={index}>
                        <td>
                          <img
                            src={`${Global.backend}/uploads/${annonce.image}`}
                            style={{ height: 100 }}
                          />
                        </td>

                        <td>{annonce.titre}</td>

                        <td>
                          {annonce.date + " (" + moment(annonce.date).fromNow() + ")"}
                        </td>


                        <td>
                          {annonce.categorie}
                        </td>


                        <td>
                          <Chip className="ms-2" label={t(annonce.etat ? (annonce.etat == -1 ? "ads.rejected" : "ads.approved") : "ads.waiting")} color={annonce.etat ? (annonce.etat == -1 ? "error" : "success") : "info"} />
                        </td>



                        <td id="tooltip-container11" className="row w-100">
                          <Button
                            disabled={annonce.etat == 1}
                            variant="contained"
                            color="success"
                            onClick={() => alertConfirm(annonce.id, 1)}
                          >
                            {t("approveAd")}
                          </Button>
                          <Button
                            disabled={annonce.etat == -1}
                            variant="contained"
                            color="error"
                            onClick={() => alertConfirm(annonce.id, -1)}
                          >
                            {t("rejectAd")}
                          </Button>
                          <Button
                            disabled={!annonce.etat}
                            variant="contained"
                            color="info"
                            onClick={() => alertConfirm(annonce.id, 0)}
                          >
                            {t("waitingAd")}
                          </Button>
                        </td>



                        <td>
                          <Tooltip title={t("view")}>
                            <IconButton
                              color="info"
                              onClick={() => navigate("/dashboard/admin/adminannoncedetails/" + annonce.id)}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Pagination itemsPerPage={10} items={annonces} setItems={setpaginatedItems} />

              </div>
            </div>
          </div>
      )}
    </LoaderComponent >
  );
};

export default AdminAnnonceList;
